<!-- 数値と単位を表示する　 -->
<template>
  <div class="value-wrapper">
    <div class="value" v-text="signValue" />
    <div class="unit">{{ unit }}</div>
  </div>
</template>

<script>
import VueTypes from "vue-types";

export default {
  props: {
    symbole: VueTypes.bool.def(false),
    value: VueTypes.number.isRequired,
    unit: VueTypes.string.isRequired
  },
  computed: {
    signValue: function() {
      if (this.symbole && this.value > 0) {
        return "+" + this.value;
      } else {
        return this.value;
      }
    }
  }
};
</script>

<style scoped>
.value-wrapper {
  display: flex;
  justify-content: center;
  align-items: baseline;
}
.value-wrapper > .unit {
  font-weight: bold;
}
@media screen and (max-width: 599px) {
  .value-wrapper > .value {
    font-size: calc(100vw / 20);
  }
  .value-wrapper > .unit {
    font-size: calc(100vw / 30);
  }
}
@media screen and (min-width: 600px) and (max-width: 959px) {
  .value-wrapper > .value {
    font-size: calc(100vw / 20);
  }
  .value-wrapper > .unit {
    font-size: calc(100vw / 30);
  }
}
@media screen and (min-width: 960px) {
  .value-wrapper > .value {
    font-size: calc(100vw / 30);
  }
  .value-wrapper > .unit {
    font-size: calc(100vw / 40);
  }
}
.value-wrapper > div {
  margin: 0;
}
</style>
